import {apiSlice} from './apiSlice';

/**
 * Endpoints module Schema.org Generator + Validator.
 *
 * - validateSchema: gửi chuỗi JSON-LD, BE validate 3 lớp, trả kết quả (stateless).
 * - getSavedSchemas / getSavedSchema: danh sách + chi tiết schema đã lưu.
 * - saveSchema: lưu 1 schema do Generator sinh → invalidate 'SavedSchema'.
 * - deleteSavedSchema: xoá 1 schema đã lưu.
 */
export const schemaApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		validateSchema: builder.mutation({
			query: (json) => ({url: 'schema/validate', method: 'post', data: {json}}),
			transformResponse: (body) => body?.data || null,
		}),
		getSavedSchemas: builder.query({
			query: (keyword = '') => ({
				url: 'schema',
				method: 'get',
				...(keyword ? {params: {keyword}} : {}),
			}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['SavedSchema'],
		}),
		getSavedSchema: builder.query({
			query: (id) => ({url: `schema/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'SavedSchema', id}],
		}),
		saveSchema: builder.mutation({
			query: (data) => ({url: 'schema/save', method: 'post', data}),
			invalidatesTags: ['SavedSchema'],
		}),
		// Cập nhật schema đã lưu (nút "Sửa" ở danh sách → mở lại Generator).
		updateSchema: builder.mutation({
			query: ({id, ...data}) => ({url: `schema/${id}`, method: 'put', data}),
			invalidatesTags: (result, error, {id}) => ['SavedSchema', {type: 'SavedSchema', id}],
		}),
		deleteSavedSchema: builder.mutation({
			query: (id) => ({url: `schema/${id}`, method: 'delete'}),
			invalidatesTags: ['SavedSchema'],
		}),
	}),
});

export const {
	useValidateSchemaMutation,
	useGetSavedSchemasQuery,
	useGetSavedSchemaQuery,
	useSaveSchemaMutation,
	useUpdateSchemaMutation,
	useDeleteSavedSchemaMutation,
} = schemaApiSlice;
